var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTwitterIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 34,
  height: 34,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 34,
  height: 34,
  fill: "#1D9BF0",
  rx: 17
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M13.889 25.967c7.54 0 11.662-6.247 11.662-11.662 0-.178 0-.357-.008-.527a8.4 8.4 0 0 0 2.048-2.125 8.3 8.3 0 0 1-2.355.646 4.1 4.1 0 0 0 1.802-2.27 8.3 8.3 0 0 1-2.6.995 4.08 4.08 0 0 0-2.992-1.292 4.1 4.1 0 0 0-4.097 4.097c0 .323.034.638.11.935A11.63 11.63 0 0 1 9.01 10.48a4.1 4.1 0 0 0-.552 2.057 4.08 4.08 0 0 0 1.827 3.409 4 4 0 0 1-1.853-.51v.05a4.1 4.1 0 0 0 3.29 4.021 4.1 4.1 0 0 1-1.853.068 4.09 4.09 0 0 0 3.825 2.848 8.24 8.24 0 0 1-6.07 1.691 11.4 11.4 0 0 0 6.265 1.853"
})));
export default SvgTwitterIcon;